import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header, { Footer } from "./components/Header/Header";
import Home from "./components/Home/Home";
import { QuoteBanner } from "./components/QuoteBanner";

const Router = () => {
  return (
    <BrowserRouter>

      <div className="page-content">
        <Header />
        <QuoteBanner />
        
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>

        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default Router;